/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class FrameworkPlannerApi extends BaseApi {
  endPoint: string = '/api/admin/framework-planners';
}
